import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-test-preview',
    templateUrl: './test-preview.component.html',
    styleUrls: ['./test-preview.component.scss'],
    standalone: false
})
export class TestPreviewComponent implements OnInit {
  constructor(private _router: Router) {}

  ngOnInit(): void {}

  goToPetition() {
    this._router.navigateByUrl('/petition-builder/petition-detail');
  }
}
